<template>

		<div>
				<v-dialog
						v-model="progress"
						hide-overlay
						internal-activator
						persistent
						width="300"
				>
						<v-card
								color="primary"
								dark
								v-if="progress"
						>
								<v-card-text>
										Processando Documento
										<v-progress-linear

												indeterminate
												color="white"
												class="mb-0"
										></v-progress-linear>
								</v-card-text>
						</v-card>
				</v-dialog>


				<v-dialog
						v-model="dialog"
						width="500"
				>
						<v-card>
								<v-card-title class="headline grey lighten-2">
										{{title}}
								</v-card-title>
								<v-card-text>

										<v-autocomplete
												v-model="selectedUserPass"
												chips
												v-if="care"
												label="Usuario"
												item-text="name"
												return-object
												clearable
												:items="usersPass"
												full-width
												dense
												single-line
										>
										</v-autocomplete>
										<v-text-field
												v-model="secret"
												placeholder="contra senha"
										>
										</v-text-field>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn
												color="primary"
												text
												@click="addCounsing"
										>
												adicionar
										</v-btn>
								</v-card-actions>
						</v-card>
				</v-dialog>
				<v-card :disabled="progress">
						<v-card-text class="pt-0">

								<validation-observer v-slot="{ passes }">
										<v-container class="down-top-padding " fluid>
												<v-row dense class="pa-4 mb-2 rounded" style="border: 2px solid #f5f5f5">
														<v-col>
																<v-row>
																		<v-col lg="6" xl="6" sm="12" md="12" cols="12" class="py-0">
																				<span>Para</span>
																				<validation-provider rules="required" v-slot="{ errors }" name="selecionarEntity">
																						<treeselect
																								v-model="valueTo"
																								:multiple="!privateDocument"
																								:value-consists-of="!privateDocument ? 'BRANCH_PRIORITY': 'LEAF_PRIORITY'"
																								:options="options"
																								placeholder="Selecionar destinatários"
																								:disableBranchNodes="privateDocument"
																								@input="userPassFunc($event)"
																						/>
																						<span style="color: #ff5252">{{ errors[0]}}</span>
																				</validation-provider>
																		</v-col>
																		<v-col lg="6" xl="6" sm="12" md="12" cols="12" class="py-0">
																				<validation-provider rules="required" v-slot="{ errors }" name="subject">
																						<span>Assunto</span>
																						<v-text-field
																								outlined
																								dense
																								v-model="subject"
																								:error-messages="errors"
																						>
																						</v-text-field>
																				</validation-provider>
																		</v-col>
																</v-row>
																<v-row>
																		<v-col lg="5" cols="12" xl="5" sm="5" md="5" class="d-flex  justify-start py-0">
																				<treeselect v-model="valueAttn" :options="optionsAttn" placeholder="A/C"/>
																		</v-col>
																		<v-col cols="12" lg="1" xl="1" sm="1" md="1" class="d-flex justify-end py-0">
																				<v-btn
																						icon
																						@click="treeselectDisable = !treeselectDisable; valueCC = null"
																						class="mr-2"
																				>
																						+Cc
																				</v-btn>
																				<v-btn
																						icon
																						@click="VtreeSelectModalDisable = !VtreeSelectModalDisable; valueBcc = null"
																				>
																						+CCo
																				</v-btn>
																		</v-col>
																		<v-col lg="6" xl="6" sm="6" md="6">
																				<v-row no-gutters class="d-flex justify-end py-0">
																						<v-col class="d-flex justify-end py-0">
																								<v-checkbox
																										hide-details
																										v-model="privateDocument"
																										label="Privado"
																										@click="valueAttn = null"
																										class="mt-0"
																										dense
																								>
																								</v-checkbox>
																						</v-col>
																						<v-col class="d-flex justify-end py-0">
																								<v-checkbox
																										hide-details
																										v-model="Urgent"
																										label="Urgente"
																										class="mt-0"
																										dense
																								>
																								</v-checkbox>
																						</v-col>
																						<v-col class="d-flex justify-end py-0">
																								<v-row no-gutters>
																										<v-menu
																												ref="menu"
																												v-model="menu"
																												:close-on-content-click="false"
																												transition="scale-transition"
																												offset-y
																												min-width="290px"
																										>
																												<template v-slot:activator="{ on }">
																														<v-row no-gutters
																														       class="d-flex justify-end py-0 mt-2 ml-2 ml-lg-0 ml-sm-0 ml-md-0 ml-xl-0">
																																Prazo:
																																<v-chip
																																		class="ml-1"
																																		color="primary"
																																		x-small

																																		v-on="on"
																																>
																																		<span class="font-weight-bold text-caption">	{{dateDeadline === '' ? 'Sem Prazo' : dateDeadline | correctDate   }}</span>
																																</v-chip>
																														</v-row>
																												</template>
																												<v-date-picker :min="currentDate" v-model="dateDeadline" no-title scrollable>
																														<div class="flex-grow-1"></div>
																														<v-btn text color="primary" @click="menu = false">Cancel</v-btn>
																														<v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
																												</v-date-picker>
																										</v-menu>
																								</v-row>
																						</v-col>
																				</v-row>
																		</v-col>
																</v-row>
																<v-row v-if="treeselectDisable">
																		<v-col lg="6" xl="6" sm="12" md="12" class="py-0">
																				<span>Cópia</span>
																				<validation-provider rules="required" v-slot="{  }" name="selectCC">
																						<treeselect v-model="valueCC" :multiple="true" :options="options"
																						            placeholder="Selecionar Destinatários"/>
																				</validation-provider>
																		</v-col>
																</v-row>
																<v-row v-if="VtreeSelectModalDisable">
																		<v-col lg="6" xl="6" sm="12" md="12">
																				<span>Cópia oculta</span>
																				<validation-provider rules="required" v-slot="{  }" name="selectBcc">
																						<treeselect v-model="valueBcc" :multiple="true" :options="options"
																						            placeholder="Selecionar Destinatários"/>
																				</validation-provider>
																		</v-col>
																</v-row>
														</v-col>
												</v-row>
												<v-row no-gutters>
														<v-col cols="12" class="mb-2">
																		<ckeditor placeholder="Type here..." v-model="valor" tag-name="textarea"
																		          :config="config"></ckeditor>
														</v-col>
												</v-row>
												<v-row dense no-gutters class="pa-4 mb-2 rounded" style="border: 2px solid #f5f5f5">
														<v-col id="profile-pic-demo" lg="12" xl="12" sm="12" md="12">
																<span>Anexos</span>

																<VueFileAgent
																		:multiple="true"
																		:deletable="true"
																		:averageColor="true"
																		:editable="true"
																		:meta="true"
																		@beforedelete="onBeforeDelete($event)"
																		:accept="'image/*,video/*,.pdf,.zip'"
																		:maxSize="'1mb'"
																		:helpText="'Selecione os Arquivos'"
																		:errorText="{
                            type: 'Selecione imagens, vídeos, arquivos PDF ou zip',
                            size: 'Você selecionou um arquivo grande!',
         }"
																		v-model="files"
																		ref="fileAgent"
																>
																</VueFileAgent>

														</v-col>
												</v-row>


												<v-row no-gutters dense justify="start" justify-lg="start" align="center">
														<v-col cols="12" lg="3" xl="3" sm="12" md="3" class=" d-flex align-start">
																<v-row align="center" no-gutters>
																		<v-col class="mt-lg-0" cols="12" lg="5">
																				<v-card rounded v-if="selectedUserPasscard" elevation="6" class="">
																						<v-card-title class="pa-0">
																								<span class=" ml-1 text-caption font-weight-bold">Usuário</span>
																								<v-spacer></v-spacer>
																								<v-card-actions class="pa-0 ">
																										<v-btn dark color="primary" @click="clearPass" icon x-small>
																												<v-icon color="primary" x-small>mdi-close</v-icon>
																										</v-btn>
																								</v-card-actions>
																						</v-card-title>
																						<v-card-text class="pa-0">
																								<v-list class="pa-0" dense>
																										<v-list-item class="pl-1">
																												<v-list-item-icon class="mr-1">
																														<v-avatar v-if="selectedUserPass.avatar" size="30">
																																<img :src="selectedUserPass.avatar" :alt="selectedUserPass.name"/>
																														</v-avatar>
																														<v-avatar v-else color="primary" size="30">
																																<span class="text--white text-h6 font-weight-bold">{{UserName.substring(0,1)}}</span>
																														</v-avatar>
																												</v-list-item-icon>
																												<v-list-item-content>
																														<v-list-item-title class="text-caption text-lg-caption font-weight-bold">
																																{{selectedUserPass.name}}
																														</v-list-item-title>
																														<v-list-item-subtitle
																																class="text-caption ">
																																{{selectedUserPass.position_pivot.position[0].name}}
																														</v-list-item-subtitle>
																												</v-list-item-content>
																										</v-list-item>
																								</v-list>
																						</v-card-text>
																				</v-card>
																				<v-card v-else height="28" elevation="3" class="text-center">
																						<v-card-text class="pa-0">
																								<span class="text-caption">Sem contrassenha</span>
																						</v-card-text>
																				</v-card>
																		</v-col>
																		<v-col class="mt-1 mt-lg-0 mt-xl-0" cols="12" lg="7" xl="6">
																				<v-btn :disabled="disableBtnUserpass" class="ml-2 text-caption" width="92%" small color="primary"
																				       @click="contrasenha">
																						Contrassenha
																				</v-btn>
																		</v-col>
																</v-row>
														</v-col>

														<v-col lg="3" xl="3" sm="3" md="3" class="mt-2 mt-lg-0 ml-lg-10  d-flex justify-center">
																<v-btn width="90%" small class="primary font-weight-regular">
																		Certificado Digital
																</v-btn>
														</v-col>
														<v-col lg="2" xl="2" sm="2" md="2" class="d-flex justify-center">
																<v-checkbox
																		label="Imprimir Folha de Rosto"
																		class="font-weight-regular"
																		v-model="cover_sheet"
																>
																</v-checkbox>
														</v-col>
														<v-col class="ml-lg-auto ml-sm-auto mt-2" col="12" lg="3" xl="3" sm="6" md="5">
																<v-row no-gutters align="center" justify="end">
																		<v-btn black small @click="passes(saveCustom)" class="mr-auto" color="primary">Salvar</v-btn>
																		<v-btn black outlined small color="primary" to="/documents">Cancelar</v-btn>
																</v-row>
														</v-col>
												</v-row>
										</v-container>
								</validation-observer>
						</v-card-text>
				</v-card>
		</div>

</template>

<script>

 import {differenceInDays} from "date-fns"
 import mixinsnotificationform from '@/mixins/notification-form'
 import {ValidationObserver, ValidationProvider} from "vee-validate"
 // eslint-disable-next-line no-unused-vars
 import movingDocument from '@/services/register-document'
 import Treeselect from '@riophae/vue-treeselect'
 import '@riophae/vue-treeselect/dist/vue-treeselect.css'

 import moment from 'moment'
 // eslint-disable-next-line no-unused-vars

	export default {
		name: "FormNewDocument",
		mixins: [mixinsnotificationform],
		data: () => ({
			fileRecords: [],
			dialogTreeTest: false,
			dialogTreeCC: false,
			menu: false,
			isEditing: false,
			autoUpdate: true,
			isUpdating: false,
			tree: [],
			treeCC: [],
			breweries: [],
			usersPass: [],
			name: 'Midnight Crew',
			treeselectDisable: false,
			VtreeSelectModalDisable: false,
			modal: false,
			ativo: false,
			secret: '',
			values: null,
			value: null,
			dialog: false,
			currentDate: moment().format("YYYY-MM-DD"),
			files: [],
			openIds: null,
			documentId: '',
			users: [],
			userAutoSelec: [],
			arrayfiles: [],
			selectedUserPass: null,
			Urgent: false,
			contraSenha: {},
			title: 'Contra Senha',
			progress: false,
			privateDocument: false,
			digitallySign: false,
			dateDeadline: '',
			subject: '',
			selectEntity: null,
			types: [],
			date: null,
			friends: [],
			disblapass: true,
			care: false,
			selectedUserEntiyAc: null,
			menu2: false,
			disableBtnUserpass:true,
			content: '',
			model: {},
			selectedUserPasscard:false,
			typesAuto: [],
			options: [],
			valueTo: null,
			valueAttn: null,
			valueCC: null,
			valueBcc: null,
			entities: null,
			entitiesAncestors: null,
			cover_sheet: null
		}),
		components: {
			ValidationObserver,
			ValidationProvider,
			Treeselect
		},
		computed: {
   config(){
    return this.$store.state.editorConfig
   },
   valor:{
    get(){
     if(this.$store.state.pivot.signature !== null){
      return `<footer style="
                 position: fixed;
                 height: 50px;
                 bottom: 0px;
                 left: 0px;
                 right: 0px;
                 margin-bottom: 0px;
                 background-color: red;
                 ">
                      <p>${this.$store.state.pivot.signature}<br>

                   </footer>`
     }else{
      return ''
     }
    },
    set(value){

     this.content = value
    }
   },
			optionsAttn() {
				if ((this.valueTo === null) || (typeof this.valueTo == 'string')) {
					return []
				}

				if (this.valueTo.length == 0) {
					return []
				}

				let data = []

				this.entitiesAncestors.forEach(e => {
					if (e.users.length > 0) {
						e.users.forEach(u => {
							data.push({
								id: `${e.id}@${u.id}`,
								label: `${u.name} - ${e.initials}`,
								eId: e.id,
								uId: u.id,
								ancestors: e.ancestors
							})
						})
					}
				})

				if (this.valueTo[0] == 'allEntities') {
					let sort = data.sort((a, b) => (a.label > b.label) ? 1 : -1)
					return sort
				}

				let data2 = []

				this.valueTo.forEach(v => {
					data.map(user => {
						if (user.id == v) {
							data2.push(user)
							return false
						} else {
							if (user.eId == v) {
								data2.push(user)
								return false
							} else {
								if (user.ancestors.length > 0) {
									user.ancestors.map(a => {
										if (a.id == v) {
											data2.push(user)
											return false
										}
									})
								}
							}
						}
					})
				})
				let sort2 = data2.sort((a, b) => (a.label > b.label) ? 1 : -1)
				return sort2
			},
			itemsTree() {
				const children = this.types.map(type => ({
					id: type.id,
					name: type.name,
					children: this.getChildren(type),
				}));

				return [{
					id: 1,
					name: 'Todas Entidades',
					children,
				}]
			},
			UserName() {
				return this.$store.state.userName
			},
			position() {
				return this.$store.state.possition.name
			},
			items() {
				return this.getNodes(this.getTree)
			},
			getTree() {
				return this.rowData ? this.toTree(this.rowData) : []
			},
			formattedDate: function () {
				// !! format the date based on this.currentLocale !!

				var time = moment().format('HH:mm:ss');


				return this.dateDeadline.length === 0 ? '' : moment(this.dateDeadline).format(`YYYY-MM-DD ${time}`);
			},
			dataCreatDocument() {
				return {
					number: Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000,
					subject: this.subject,
					content: this.content,
					delivery_time: this.formattedDate,
					privateDocument: this.privateDocument,
					urgent: this.Urgent,
					client: this.$store.state.defaultClient.id,
					entity: this.$store.state.enti.id,
					document_type: this.getTypedocument,
					user: this.$store.state.userID,
					$countersign: this.contraSenha.id,
					$countersign_user: this.selectedUserPass.id,
					parent: null,
					att_user: this.selectedUserEntiyAc,
					att_entity: this.selectEntity.id,
					initial_document: null
				}
			},
			dataTosendDestiny() {
				return {
					entity: this.selectEntity.id,
					user: this.selectedUserEntiyAc,
					receiver_type: this.receiverType,
					receiver_category: this.ReceiverCategory
				}
			},
			dataTosendForme() {
				return {
					entity: this.$store.state.enti.id,
					user: this.$store.state.userID,
					receiver_type: this.receiverType,
					receiver_category: this.ReceiverCategory
				}
			},
		},
		watch: {
			dialogTreeCC(val) {
				if (val) {
					this.treeCC = []
				}
			},
			tree(val) {
				const arrayUser = [];
				for (const j of val) {
					if (j.children === undefined) {
						arrayUser.push(j)
					}
				}

				this.values = arrayUser
			},
			breweries(val) {
				this.types = val.reduce((acc, cur) => {

					const type = cur;
					if (!acc.includes(type)) acc.push(type);
					return acc
				}, []).sort()
			},

			// itemsTreeSelect(val){
			// },
			isUpdating(val) {
				if (val) {
					setTimeout(() => (this.isUpdating = false), 3000)
				}
			},

			selectedUserPass() {
				this.disblapass = false
			},
			// eslint-disable-next-line no-unused-vars
			selectEntity(val) {
				if (val !== undefined) {
					this.users = val.users
				}
			}
		},
		methods: {
			userPassFunc(event){
				event.length !== 0 ? this.disableBtnUserpass = false :  this.disableBtnUserpass = true
			},
			async getEntiitesTree() {
				await this.$apollo.query({
					query: require('@/graphql/queries/Entity2.gql').getEntitiesOrderBy,
				}).then(({data}) => {
					this.entities = data.entities
				}).catch((err) => {
					console.error(err)
				})

				let entities = this.entities.map((x) => x)
				//let finalTree = this.makeFinalTree(entities)
				let finalTree = this.toTreeNew(entities)

				this.options = ([{id: 'allEntities', label: 'Todos os Departamentos', children: finalTree}])
			},
			async getEntiitesAncestors() {
				await this.$apollo.query({
					query: require('@/graphql/queries/Entity2.gql').getEntiitesAncestors,
				}).then(({data}) => {
					this.entitiesAncestors = data.entities
				}).catch((err) => {
					console.error(err)
				})
			},
			saveCustom() {
			  console.log('teste')
     this.progress = true
				this.$apollo.mutate({
					mutation: require('@/graphql/mutations/Document2.gql').createCustomDocument,
					variables: {
						number: Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000,
						subject: this.subject,
						content: this.content,
						delivery_time: this.formattedDate,
						privateDocument: this.privateDocument,
						urgent: this.Urgent,
						cover_sheet: this.cover_sheet,
						client: this.$store.state.defaultClient.id,
						entity: this.$store.state.enti.id,
						document_type: this.getTypedocument,
						user: this.$store.state.userID,
						countersign: this.contraSenha === null ? null :this.contraSenha.id,
						countersign_user: this.selectedUserPass === null ? null: this.selectedUserPass.id,
						parent: null,
						initial_document: null,
						to: this.valueTo,
						attn: this.valueAttn,
						cc: this.valueCC,
						bcc: this.valueBcc,
					}
				}).then(({data: {createCustomDocument}}) => {
					const dataDucumentFiles = movingDocument.filesDocument(this.files, createCustomDocument[0].id)

					if (dataDucumentFiles) {
						this.$router.replace('documents')
					} else {
						console.log('faltou')
					}
				}).catch(({graphQLErrors}) => {
					console.error(graphQLErrors)
				});
			},
			toTreeNew(entities, tree) {
				if (!tree) tree = entities.filter(c => !c.parent_id);
				tree = tree.map(parentNode => {
					const isChild = node => node.parent_id === parentNode.id;

					parentNode.children = this.toTreeNew(entities, entities.filter(isChild));

					parentNode.users.map((u) => {
						let user = {id: `${parentNode.id}@${u.id}`, label: u.name}
						parentNode.children.unshift(user)
					})

					return parentNode
				});
				return tree
			},

			clearPass() {
				this.selectedUserPasscard = false
				this.selectedUserPass = {}
				this.secret = null
				this.valueTo.length == 1 ? this.disableBtnUserpass = false : this.disableBtnUserpass = true
			},
			onBeforeDelete(fileRecord) {
				this.$refs.fileAgent.deleteFileRecord(fileRecord);
			},

			fetch() {

				if (this.breweries.length) return;

				return this.$apollo.query({
					query: require('@/graphql/queries/Entity.gql').getEntitesUSers,

				}).then((data) => {

					this.breweries = data.data.entities
				}).catch((err) => {
					console.error(err)
				})


			},
			getChildren(type) {
				// const breweries = []
				const userChild = [];
				for (const brewery of this.breweries) {
					if (brewery.id !== type.id) continue;


					if (brewery.users.length !== 0) {
						for (const j of brewery.users) {
							userChild.push({
								...j,
								name: this.getName(j.name)
							})

						}

					}
				}

				return userChild.sort((a, b) => {
					return a.name > b.name ? 1 : -1
				})
			},
			getName(name) {
				return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
			},
			removet(item) {

				const index = this.tree.indexOf(item.name);

				this.tree.splice(index, 1)

			},
			removetcc(item) {

				const index = this.treeCC.indexOf(item.name);

				this.treeCC.splice(index, 1)

			},

			async createDocument() {
				this.progress = true

				const dataDocument = await movingDocument.createDocument(this.dataCreatDocument)
				await movingDocument.sendingToDestination(this.dataTosendDestiny, dataDocument.id)
				await movingDocument.sendingToMe(this.dataTosendForme, dataDocument.id)
				const dataDucumentFiles = await movingDocument.filesDocument(this.files, dataDocument.id)

				if (dataDucumentFiles) {
					this.$router.replace('documents')
				} else {
					console.log('faltou')
				}
			},
			showinput() {
				if (this.selectEntity) {
					this.care = true
				}
			},
			addCounsing() {
				console.log({
					id: this.selectedUserPass.id,
					secret: this.secret
				})
				this.$apollo.mutate({
					mutation: require('@/graphql/mutations/Documents.gql').CountersignUser,
					variables: {
						id: this.selectedUserPass.id,
						secret: this.secret
					}
				}).then(({data:{customCountersignQuery}}) => {
					console.log(customCountersignQuery)
					console.log(customCountersignQuery)
					if(customCountersignQuery === null){
						this.selectedUserPasscard = null
      this.selectedUserPass = null
						this.contraSenha = null
						this.$toasted.global.defaultError( 'Contrassnha Incorreta!');
						this.clearPass()
					}else{
						this.contraSenha = customCountersignQuery
						this.$toasted.global.defaultSuccess('Assinado Com Sucesso!');
						this.selectedUserPasscard = true
						this.disableBtnUserpass = true
						console.log(this.contraSenha)
					}
				}).catch((err) => {
					console.error(err);
					this.$toasted.global.defaultError('Usuario não tem contrassenha!');
				});
				this.dialog = false
			},
			cliativit() {
				this.ativo = true
			},
			// eslint-disable-next-line no-unused-vars
			getValue(val) {
				this.content = val;
				this.ativo = false
			},
			remove(index) {
				this.files.splice(index, 1)
			},
			async contrasenha() {

				await this.$apollo.query({
					query: require('@/graphql/queries/Entity.gql').DataQueryId,
					variables: {
						id: this.$store.state.enti.id
					}
				}).then(({data: {entity}}) => {
					this.usersPass = entity.users
					console.log(this.usersPass)
				}).catch((err) => {
					console.log(err)
				})

				// this.care = true;
				// this.dialog = true

				if (this.valueTo) {
					this.care = true;
					this.dialog = true
				} else {
					this.care = false;
					this.dialog = false
				}
			},
			getNodes(items) {
				let no = items.map(item => ({
					id: item.id,
					name: item.name,
					children: item.children ? this.getNodes(item.children) : item.users
				}));
				return no
			},
			toTree(entities, tree) {
				if (!tree) tree = entities.filter(c => !c.parent_id);
				tree = tree.map(parentNode => {
					const isChild = node => node.parent_id === parentNode.id;
					parentNode.children = this.toTree(entities, entities.filter(isChild));
					return parentNode
				});
				return tree
			},
			datePrazo(item) {
				if (!item) return '';
				const startDate = new Date();
				const endDate = item;
				let diffInDays = differenceInDays(new Date(endDate), new Date(startDate));
				if (diffInDays < 0) return diffInDays * -1;

				return diffInDays
			},
		},
		apollo: {
			getEntities: {
				query: require('@/graphql/queries/Entity.gql').getEntitiesSelectUser,
				update: (data) => {
					return data.entities
				},
				error: (error) => {
					console.error(error)
				}
			},
			getTypedocument: {
				query: require('@/graphql/queries/Documents.gql').documentTypesalias,
				variables: {
					alias: "memorando"
				},
				update: (data) => {
					return data.documentType.id
				}
			},
			receiverType: {
				query: require('@/graphql/queries/Documents.gql').ReceiverTypesAlias,
				variables: {
					alias: "to"
				},
				update: (data) => {
					return data.receiverType.id
				}
			},
			ReceiverCategory: {
				query: require('@/graphql/queries/Documents.gql').ReceiverCategoryAlias,
				variables: {
					alias: "sent"
				},
				update: (data) => {
					return data.receiverCategory.id
				}
			},
			rowData: {
				query: require('@/graphql/queries/TreeView.gql').getTreeView,
				update: data => {

					return data.entities
				}
			}
		},
		async  mounted() {


   this.getEntiitesTree()
			this.getEntiitesAncestors()
		}
	}
</script>

<style scoped>
	.v-progress-circular {
		margin: 1rem;
	}

	#profile-pic-demo .drop-help-text {
		display: inline;
	}

	#profile-pic-demo .is-drag-over .drop-help-text {
		display: block;
	}

	#profile-pic-demo .profile-pic-upload-block {
		border: 2px dashed transparent;
		padding-top: 0;
	}

	#profile-pic-demo .is-drag-over .profile-pic-upload-block {
		border-color: #AAA;
		height: 10%;
	}

	#profile-pic-demo .vue-file-agent {
		width: 1000px;
		float: left;
		margin: 0 15px 5px 0;
		border: 0;
		box-shadow: none;
	}

	#profile-pic-demo .grid-block-wrapper .vue-file-agent .file-input-wrapper .has-multiple {
		height: 10px;
	}

	#profile-pic-demo > canvas {
		height: 10px;
	}

</style>